import Config from './config';

export default {
    install(Vue, options) {
        Vue.prototype.$config = new Config(options.config || {});
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-configuration/src/index.js
// module id = null
// module chunks = 